module.exports = __webpack_public_path__ + "img/add.68f6e21a.svg";